import { Checkbox, Form } from 'antd';
import React from 'react'
import '../../assets/styles/scss/common/_checkbox.scss'
import { InfoCircleOutlined } from '@ant-design/icons';

const CheckBoxUC = (props) => {
    const {
        name,
        isShowHead = true,
        label,
        onChange,
        tooltipTitle = null,
        tooltipPlacement = 'topLeft',
        disabled,
        checked = false
    } = props;
    return (
        <>
            <Form.Item
                name={name}
                label={isShowHead ? label : ""}
                valuePropName={'checked'}
                tooltip={tooltipTitle ? {
                    title: tooltipTitle,
                    icon: <InfoCircleOutlined />,
                    placement: tooltipPlacement,
                    className: "label-Tooltip color-information"
                } : null}
            >
                <Checkbox
                    checked={checked}
                    disabled={disabled}
                    onChange={onChange}
                >
                    {label}
                </Checkbox>
            </Form.Item>
        </>
    )
}

export default CheckBoxUC